// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1r-dN","title":"Images45_title__KWT_K","images":"Images45_images__3cetA"};